

$(document).ready(function(){
  
  // ADDED VERTCAL COLLAPSING TAB FUNCTIONALITY
  $('.collapse').on('shown.bs.collapse', function(){
    $(this).parent().find(".fa-plus-circle").removeClass("fa-plus-circle").addClass("fa-minus-circle");
  }).on('hidden.bs.collapse', function(){
    $(this).parent().find(".fa-minus-circle").removeClass("fa-minus-circle").addClass("fa-plus-circle");
  });
  
  
  
});

//ON READY
function onReady(callback) {
  var intervalID = window.setInterval(checkReady, 1000);

  function checkReady() {
    if (document.getElementsByTagName('body')[0] !== undefined) {
      window.clearInterval(intervalID);
      callback.call(this);
    }
  }
}


//SHOW
function show(id, value) {
  document.getElementById(id).style.display = value ? 'block' : 'none';
}
